import { useEffect, useRef, useState } from 'react'

const useGenerateLabelModal = ({ show, includesRejectedItems }) => {
  const [includeRejectedItems, setIncludeRejectedItems] = useState(!!includesRejectedItems)
  const [discardLabels, setDiscardLabels] = useState(false)
  const previousShow = useRef(show)

  useEffect(() => {
    if (show && !previousShow.current) {
      setIncludeRejectedItems(!!includesRejectedItems)
      setDiscardLabels(false)
    }

    previousShow.current = show
  }, [show, includesRejectedItems])

  return {
    includeRejectedItems,
    handleChangeIncludeRejectedItems: setIncludeRejectedItems,
    discardLabels,
    handleChangeDiscardLabels: setDiscardLabels,
  }
}

export default useGenerateLabelModal
